<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="selected === undefined ? '12' : '6'">
        <v-list>
          <v-list-item-group v-model="selected">
            <v-list-item
              v-for="right in accessesData"
              :key="right.id"
            >
              <v-list-item-title>{{ right.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon v-if="right.id == 0">mdi-shield-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="selected !== undefined"
        cols="6"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="accessesData[selected].name"
                :rules="[rules.required]"
                :label="$t('profile.sections.common.name')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-treeview
                v-model="accessesData[selected].accesses"
                :items="$t('profile.accesses')"
                :selectable="accessesData[selected].accesses.length < 8"
                dense
              />
            </v-col>
          </v-row>
          <v-row v-if="accessesData[selected].id == 0">
            <v-col cols="12">
              <v-btn
                color="success"
                :disabled="accessesData[selected].name.length < 1 || accessesData[selected].accesses.length < 1"
                @click="createAccess()"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.create") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="6">
              <v-btn
                color="primary"
                :disabled="
                  accessesData[selected].name.length < 1 ||
                  accessesData[selected].accesses.length < 1 ||
                  accessesData[selected].accesses.length >= 8
                "
                @click="updateAccessData(accessesData[selected].id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <button-dialog-delete
                btn-icon="mdi-delete"
                :is-button-disabled="
                  accessesData[selected].accesses.length < 1 || accessesData[selected].accesses.length >= 8
                "
                :text="$t('popup.access')"
                @ok-pushed="deleteAccess(accessesData[selected].id)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";

// Connectors
import { ProfileAccessConnector } from "../Database/ProfileAccessConnector.js";

export default {
  components: {
    buttonDialogDelete,
  },
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      selected: undefined,
      accessesData: [],
      previousAccesses: [],
      previousSelected: undefined,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
      },
    };
  },
  watch: {
    accessesData: {
      handler(newVal) {
        // TODO: Not bad but not good enough the display isn't corrected when we step back
        if (this.accessesData[this.selected] !== undefined) {
          if (newVal[this.selected].accesses.length < 8) {
            this.previousAccesses = newVal[this.selected].accesses;
            this.previousSelected = this.selected;
          } else {
            if (this.previousSelected == this.selected) {
              this.accessesData[this.selected].accesses = this.previousAccesses;
              this.$store.dispatch("openSnackbar", {
                title: this.$t("dialog.warning"),
                txt: this.$t("profile.sections.access.no-admin"),
                colorBg: "orange",
              });
            }
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getListAccess();
    }
  },
  methods: {
    getListAccess() {
      this.accessConnector
        .getListAccess()
        .then((response) => {
          // TODO: format in db server
          this.accessesData = response.map((data) => {
            return {
              id: data.id_right,
              name: data.name,
              accesses: data.permissions.split("|").map((perm) => {
                return parseInt(perm);
              }),
            };
          });

          this.accessesData.unshift({
            id: 0,
            name: this.$t("profile.sections.access.new"),
            accesses: [],
          });
        })
        .catch((err) => {
          console.error("Error on get Access : " + err);
        });
    },
    createAccess() {
      if (this.accessesData[this.selected].name.length > 0 && this.accessesData[this.selected].accesses.length > 0) {
        this.accessConnector
          .insertAccessData(this.accessesData[this.selected])
          .then(() => {
            this.getListAccess();
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.create"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
    updateAccessData(rid) {
      if (this.accessesData[this.selected].name.length > 0 && this.accessesData[this.selected].accesses.length > 0) {
        this.accessConnector
          .updateAccessData(this.accessesData[this.selected], rid)
          .then(() => {
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
    deleteAccess(rid) {
      if (rid > 0) {
        this.accessConnector
          .deleteAccessData(rid)
          .then(() => {
            this.accessesData.splice(this.selected, 1);
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.delete"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
  },
};
</script>

<style></style>
